import React, { useState } from "react";
import styles from "./Login.module.css";
import logo from "../../assets/logo/oakawe.png";
import { TextField } from "@mui/material";

// import { PostMethod } from "../../service/api-service";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import axios from "axios";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const signUpHandler = async (e) => {
    e.preventDefault();
    // const API_URL = "https://oakaweapi.herokuapp.com/api/v1/auth/";
    // axios
    //   .post(
    //     API_URL + "login",
    //     {
    //       email,
    //       password,
    //     },
    //     {
    //       withCredentials: true,
    //       crossDomain: true,
    //       headers: {
    //         "Access-Control-Allow-Origin": "https://oakaweapi.herokuapp.com",
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   )
    //   .catch((error) => {
    //     return error.response.data;
    //   })
    //   .then((response) => {
    //     if (response.data) {
    //       localStorage.setItem("user", JSON.stringify(response.data));
    //     }
    //     return response.data;
    //   });
    // if (!email) {
    //   toast.warning("Please enter the email");
    //   return;
    // }
    // if (!password) {
    //   toast.warning("Please enter the password");
    //   return;
    // }
    try {
      const res = await axios.post("api/v1/auth/login", { email, password });
    //   const res = await axios.request(
    //     PostMethod("api/v1/auth/login", { email, password })
    //   );
      console.log(res.data);
      if (res.status === "200" || res.statusText === "OK") {
        console.log(res);
        // toast.success("Successfully Login In");

        localStorage.setItem("status", "success");
        // localStorage.setItem("token", res.data.accessToken);
        window.location.reload();
        return;
      }
    } catch (error) {
      console.log(error);
      console.log(error.response.data.message);
    //   toast.error(error.response.data.message);
    }
  };
  //   const [values, setValues] = React.useState({
  //     amount: "",
  //     password: "",
  //     weight: "",
  //     weightRange: "",
  //     showPassword: false,
  //   });
  //   const handleChange = (prop) => (event) => {
  //     setValues({ ...values, [prop]: event.target.value });
  //   };

  //   const handleClickShowPassword = () => {
  //     setValues({
  //       ...values,
  //       showPassword: !values.showPassword,
  //     });
  //   };
  //   const handleMouseDownPassword = (event) => {
  //     event.preventDefault();
  //   };
  return (
    <>
      <div className={styles.limiter}>
        <div className={styles.container_login}>
          <div className={styles.wrap_login}>
            <span className={styles.login_form_title}>
              <img src={logo}></img>
            </span>
            <form className={styles.login_form}>
              {/* <span className={styles.login_form_title}>Welcome</span> */}

              <TextField
                sx={{ width: "100%" }}
                id="outlined-search"
                label="Email"
                type="email"
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                sx={{ width: "100%", marginTop: 3 }}
                id="outlined-search"
                label="password"
                type="password"
                onChange={(e) => setPassword(e.target.value)}
              />
              {/* <FormControl
                sx={{
                  m: 1,
                  width: "100%",
                  margin: "16px 0px 0px 0px !important",
                }}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-adornment-password">
                  Password
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={values.showPassword ? "text" : "password"}
                  value={values.password}
                //   onChange={(e) => setPassword(e.target.value)}
                  onChange={handleChange("password")}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl> */}
              <div className={styles.button_container}>
                <button onClick={signUpHandler}>LOGIN</button>
              </div>
              {/* <div className={styles.wrap_input}>
                <input type="text" name="email" placeholder="Email"/>
                <span className={styles.focus_input} data-placeholder="Email"></span>
              </div> */}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
